import {
  FlexColumn,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useMemo } from 'react';
import { DocumentaryEvidenceItem } from './DocumentaryEvidenceItem';
import { DocumentEvidence } from '../../../../contexts/tasks';

const DocumentaryEvidenceContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[3]};
`}`;

const DocumentaryEvidenceList = styled(FlexColumn)`${({ theme }) => `
  margin-top: ${theme.padding[1]};
  gap: ${theme.padding[3]};
`}`;

const DocumentaryEvidenceHeaderTitle = styled.p`${({ theme }) => `
  color: ${theme.colours.neutral[1]};
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
`}`;

const DocumentaryEvidenceFileUpload = styled.div``;

export function DocumentaryEvidence({ documents, taskIndex }: { documents: DocumentEvidence[], taskIndex: number }) {
  const documentIndices = useMemo(() => documents.reduce((prev, current, index) => ({
    ...prev,
    [current.documentId]: index,
  }), {} as Record<string, number>), [documents]);

  return (
    <DocumentaryEvidenceContainer>
      <DocumentaryEvidenceHeaderTitle>Documentary evidence</DocumentaryEvidenceHeaderTitle>
      <DocumentaryEvidenceList>
        {documents.map(
          (document: DocumentEvidence) => (
            <DocumentaryEvidenceItem
              key={document.documentId}
              documentIndex={documentIndices[document.documentId]}
              document={document}
              taskIndex={taskIndex}
            />
          ),
        )}
      </DocumentaryEvidenceList>
      <DocumentaryEvidenceFileUpload />
    </DocumentaryEvidenceContainer>
  );
}
